// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md

import { html } from 'lit';
if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill");
}
import { Router } from '@thepassle/app-tools/router.js';
import { lazy } from '@thepassle/app-tools/router/plugins/lazy.js';

// @ts-ignore
import { title } from '@thepassle/app-tools/router/plugins/title.js';

// Eagerly load the default landing screen for fast initial render
import './pages/home/home.wc.js';

const baseURL: string = (import.meta as any).env.BASE_URL;

/**
 * Resolves router paths relative to the Vite base URL.
 */
export function resolveRouterPath(unresolvedPath?: string) {
  let resolvedPath = baseURL || '/';
  if (unresolvedPath) {
    resolvedPath = resolvedPath.endsWith('/') ? resolvedPath + unresolvedPath : `${resolvedPath}/${unresolvedPath}`;
  }
  return resolvedPath;
}

export const router = new Router({
  routes: [
    {
      path: resolveRouterPath(),
      title: 'javi.adv | Inicio',
      render: () => html`<ja-home></ja-home>`
    },
    {
      path: resolveRouterPath('store'),
      title: 'javi.adv | Tienda',
      plugins: [
        lazy(() => import('./pages/store/store.wc.js'))
      ],
      render: () => html`<store-screen></store-screen>`
    }
  ]
});